import { Component, Input, OnInit } from "@angular/core";
import { DataService_Student_Scan_History } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-student-scan-view-details",
	templateUrl: "./student-scan-view-details.component.html",
	styleUrls: ["./student-scan-view-details.component.css"],
})
export class StudentScanViewDetailsComponent implements OnInit {
	constructor(private ScanHistoryService: DataService_Student_Scan_History) {}

	ngOnInit(): void {
		this.LoadScanDetails();
	}

	ngOnChanges() {
		this.LoadScanDetails();
	}

	/////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////

	//Input
	@Input() SelectedEntry: any;

	//
	//Form
	//

	LogDTDesc: any = "";

	//Entry
	UsedForAttendance: any = "";
	EntryDate: any = "";
	EntryTime: any = "";
	AttendanceStatusDesc: any = "";
	ExcuseDesc: any = "";
	ReleaseTypeDesc: any = "";
	SuspendedDesc: any = "";
	CreatedByName: any = "";
	Comment: any = "";
	TentativeDesc: any = "";

	//Exit
	StudentHasRelease: any = "";
	//ReleaseTypeDesc: any = "";
	AdminName: any = "";
	IsAGroupAction: any = "";
	GroupActionDesc: any = "";
	GroupDesc: any = "";
	//ExcuseDesc: any = "";
	StartDate: any = "";
	EndDate: any = "";
	AdmitTime: any = "";
	ReleaseTime: any = "";
	//Comment: any = "";
	ReleaseActiveDesc: any = "";
	DaysArr: any = [];
	DaysStr: any = "";

	//Meal
	MealHistoryExists: any = "";
	MealHistoryDT: any = "";
	MealName: any = "";
	MealStartTime: any = "";
	MealEndTime: any = "";
	MealPrice: any = "";
	MealSubsidyDesc: any = "";

	//Access
	ScanAccessModeID: any = "";
	ScanAccessModeDesc: any = "";
	CourseTypeID: any = "";
	CourseTypeDesc: any = "";
	SectionInfo: any = "";
	RoomNo: any = "";

	//Time Stamp
	TimeScanID: any = "";
	TimeScanTypeID: any = "";
	TimeScanDT: any = "";
	TimeScanTypeDesc: any = "";

	//Event
	EventScanID: any = "";
	EventID: any = "";
	EventDescriptionID: any = "";
	EventDescShort: any = "";
	EventDescLong: any = "";
	EventLocation: any = "";
	EventDT: any = "";
	DoorsOpenTime: any = "";
	StartTime: any = "";
	EndTime: any = "";
	ScheduleID: any = "";
	RecurranceTypeID: any = "";
	RecurranceTypeDesc: any = "";
	RangeStartDate: any = "";
	RangeEndDate: any = "";

	/////////////////////////////////////////////

	/////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////

	//
	// Select which method to use and handle errors
	//
	LoadScanDetails() {
		this.ResetData();

		if (this.SelectedEntry == undefined) {
			return;
		}
		//Entry
		else if (this.SelectedEntry.StationModeID == 1) {
			this.loadEntryDetails();
		}
		//Exit
		else if (this.SelectedEntry.StationModeID == 2) {
			this.loadExitDetails();
		}
		//Meal
		else if (this.SelectedEntry.StationModeID == 3) {
			this.loadMealDetails();
		}
		//Access
		else if (this.SelectedEntry.StationModeID == 4) {
			this.loadAccessDetails();
		}
		//Time
		else if (this.SelectedEntry.StationModeID == 5) {
			this.loadTimeDetails();
		}
		//Event
		else if (this.SelectedEntry.StationModeID == 6) {
			this.loadEventDetails();
		}
	}

	ResetData() {
		this.LogDTDesc = "";

		//Entry
		this.UsedForAttendance = "";
		this.EntryDate = "";
		this.EntryTime = "";
		this.AttendanceStatusDesc = "";
		this.ExcuseDesc = "";
		this.ReleaseTypeDesc = "";
		this.SuspendedDesc = "";
		this.CreatedByName = "";
		this.Comment = "";
		this.TentativeDesc = "";

		//Exit
		this.StudentHasRelease = "";
		this.AdminName = "";
		this.IsAGroupAction = "";
		this.GroupActionDesc = "";
		this.GroupDesc = "";
		this.StartDate = "";
		this.EndDate = "";
		this.AdmitTime = "";
		this.ReleaseTime = "";
		this.ReleaseActiveDesc = "";
		this.DaysArr = [];
		this.DaysStr = "";

		//Meal
		this.MealHistoryExists = "";
		this.MealHistoryDT = "";
		this.MealName = "";
		this.MealStartTime = "";
		this.MealEndTime = "";
		this.MealPrice = "";
		this.MealSubsidyDesc = "";

		//Access
		this.ScanAccessModeID = "";
		this.ScanAccessModeDesc = "";
		this.CourseTypeID = "";
		this.CourseTypeDesc = "";
		this.SectionInfo = "";
		this.RoomNo = "";

		//Time
		this.TimeScanID = "";
		this.TimeScanTypeID = "";
		this.TimeScanDT = "";
		this.TimeScanTypeDesc = "";

		//Event
		this.EventScanID = "";
		this.EventID = "";
		this.EventDescriptionID = "";
		this.EventDescShort = "";
		this.EventDescLong = "";
		this.EventLocation = "";
		this.EventDT = "";
		this.DoorsOpenTime = "";
		this.StartTime = "";
		this.EndTime = "";
		this.ScheduleID = "";
		this.RecurranceTypeID = "";
		this.RecurranceTypeDesc = "";
		this.RangeStartDate = "";
		this.RangeEndDate = "";
	}

	loadEntryDetails() {
		var result = this.ScanHistoryService.StudentEntryScanInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				var r: any = response[0];

				this.LogDTDesc = r.LogDTDesc;
				this.UsedForAttendance = r.AttendanceExists;

				if (this.UsedForAttendance != "No") {
					this.EntryDate = moment(new Date(r.EntryDate)).format("MM/DD/YYYY");
					if (r.EntryDate == "" || String(this.EntryDate).toLowerCase().indexOf("invalid") != -1) {
						this.EntryDate = "N/A";
					}

					this.EntryTime = moment(new Date("1900-01-01 " + r.EntryTime)).format("h:mm:ss a");
					if (r.EntryTime == "" || String(this.EntryTime).toLowerCase().indexOf("invalid") != -1) {
						this.EntryTime = "N/A";
					}

					this.AttendanceStatusDesc = r.AttendanceStatusDesc;
					this.ExcuseDesc = r.ExcuseDesc;
					this.ReleaseTypeDesc = r.ReleaseTypeDesc;
					this.SuspendedDesc = r.SuspendedDesc;
					this.CreatedByName = r.CreatedByName;
					this.Comment = r.Comment;
					this.TentativeDesc = r.TentativeDesc;
				}
			},
			(error) => {}
		);
	}

	loadExitDetails() {
		var result = this.ScanHistoryService.StudentExitScanInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				var r: any = response[0];

				this.LogDTDesc = r.LogDTDesc;
				this.StudentHasRelease = r.StudentHasRelease;

				if (this.StudentHasRelease != "No") {
					this.ReleaseTypeDesc = r.ReleaseTypeDesc;
					this.AdminName = r.AdminName;
					this.IsAGroupAction = r.IsAGroupAction;
					this.GroupActionDesc = r.GroupActionDesc;
					this.GroupDesc = r.GroupDesc;
					this.ExcuseDesc = r.ExcuseDesc;
					this.StartDate = moment(new Date(r.StartDate)).format("MM/DD/YYYY");
					if (r.StartDate == "" || String(this.StartDate).toLowerCase().indexOf("invalid") != -1) {
						this.StartDate = "N/A";
					}

					this.EndDate = moment(new Date(r.EndDate)).format("MM/DD/YYYY");
					if (r.EndDate == "" || String(this.EndDate).toLowerCase().indexOf("invalid") != -1) {
						this.EndDate = "N/A";
					}

					this.AdmitTime = moment(new Date("1900-01-01 " + r.AdmitTime)).format("h:mm:ss a");
					if (r.AdmitTime == "" || String(this.AdmitTime).toLowerCase().indexOf("invalid") != -1) {
						this.AdmitTime = "N/A";
					}

					this.ReleaseTime = moment(new Date("1900-01-01 " + r.ReleaseTime)).format("h:mm:ss a");
					if (r.ReleaseTime == "" || String(this.ReleaseTime).toLowerCase().indexOf("invalid") != -1) {
						this.ReleaseTime = "N/A";
					}

					this.Comment = r.Comment;
					this.ReleaseActiveDesc = r.ReleaseActiveDesc;

					if (r.DaySun == 1) {
						this.DaysArr = [...this.DaysArr, "Sunday"];
					}
					if (r.DayMon == 1) {
						this.DaysArr = [...this.DaysArr, "Monday"];
					}
					if (r.DayTue == 1) {
						this.DaysArr = [...this.DaysArr, "Tuesday"];
					}
					if (r.DayWed == 1) {
						this.DaysArr = [...this.DaysArr, "Wednesday"];
					}
					if (r.DayThu == 1) {
						this.DaysArr = [...this.DaysArr, "Thursday"];
					}
					if (r.DayFri == 1) {
						this.DaysArr = [...this.DaysArr, "Friday"];
					}
					if (r.DaySat == 1) {
						this.DaysArr = [...this.DaysArr, "Saturday"];
					}

					this.DaysStr = "";

					if (this.DaysArr.length == 0) {
						this.DaysStr = "N/A";
					} else {
						for (var i = 0; i < this.DaysArr.length; i++) {
							this.DaysStr += this.DaysArr[i];

							if (i != this.DaysArr.length - 1) {
								this.DaysStr += ", ";
							}
						}
					}
				}
			},
			(error) => {}
		);
	}

	loadMealDetails() {
		var result = this.ScanHistoryService.StudentMealScanInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				var r: any = response[0];

				this.LogDTDesc = r.LogDTDesc;
				this.MealHistoryExists = r.MealHistoryExists;

				if (r.MealHistoryExists != "No") {
					this.MealHistoryDT = moment(new Date(r.MealHistoryDT)).format("MM/DD/YYYY");
					if (r.MealHistoryDT == "" || String(this.MealHistoryDT).toLowerCase().indexOf("invalid") != -1) {
						this.MealHistoryDT = "";
					}

					this.MealName = r.MealName;

					this.MealStartTime = moment(new Date(r.MealStartTime)).format("h:mm a");
					if (r.MealStartTime == "" || String(this.MealStartTime).toLowerCase().indexOf("invalid") != -1) {
						this.MealStartTime = "N/A";
					}

					this.MealEndTime = moment(new Date(r.MealEndTime)).format("h:mm a");
					if (r.MealEndTime == "" || String(this.MealEndTime).toLowerCase().indexOf("invalid") != -1) {
						this.MealEndTime = "N/A";
					}

					if (r.MealPrice != "") {
						this.MealPrice = "$" + r.MealPrice;
					}

					this.MealSubsidyDesc = r.MealSubsidyDesc;
				}
			},
			(error) => {}
		);
	}

	loadAccessDetails() {
		var result = this.ScanHistoryService.StudentAccessScanInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				var r: any = response[0];

				this.LogDTDesc = r.LogDTDesc;
				this.ScanAccessModeID = r.ScanAccessModeID;
				this.ScanAccessModeDesc = r.ScanAccessModeDesc;
				this.CourseTypeID = r.CourseTypeID;
				this.CourseTypeDesc = r.CourseTypeDesc;
				this.SectionInfo = r.SectionInfo;
				this.RoomNo = r.RoomNo;
			},
			(error) => {}
		);
	}

	loadTimeDetails() {
		var result = this.ScanHistoryService.StudentTimeScanInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				var r: any = response[0];

				this.LogDTDesc = r.LogDTDesc;
				this.TimeScanID = r.TimeScanID;

				if (this.TimeScanID > 0) {
					this.TimeScanTypeID = r.TimeScanTypeID;

					this.TimeScanDT = moment(new Date(r.TimeScanDT)).format("MM/DD/YYYY h:mm a");
					if (r.TimeScanDT == "" || String(this.TimeScanDT).toLowerCase().indexOf("invalid") != -1) {
						this.TimeScanDT = "N/A";
					}

					this.TimeScanTypeDesc = r.TimeScanTypeDesc;
				} else {
					this.TimeScanDT = "N/A";
					this.TimeScanTypeDesc = "N/A";
				}
			},
			(error) => {}
		);
	}

	loadEventDetails() {
		var result = this.ScanHistoryService.StudentEventScanInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				var r: any = response[0];

				this.LogDTDesc = r.LogDTDesc;
				this.EventScanID = r.EventScanID;
				this.EventID = r.EventID;

				if (this.EventScanID > 0 && this.EventID > 0) {
					this.EventDescriptionID = r.EventDescriptionID;
					this.EventDescShort = r.EventDescShort;
					this.EventDescLong = r.EventDescLong;
					this.EventLocation = r.EventLocation;

					this.EventDT = moment(new Date(r.EventDT)).format("MM/DD/YYYY h:mm a");
					if (r.EventDT == "" || String(this.EventDT).toLowerCase().indexOf("invalid") != -1) {
						this.EventDT = "N/A";
					}

					this.DoorsOpenTime = moment(new Date(r.DoorsOpenTime)).format("h:mm a");
					if (r.DoorsOpenTime == "" || String(this.DoorsOpenTime).toLowerCase().indexOf("invalid") != -1) {
						this.DoorsOpenTime = "N/A";
					}

					this.StartTime = moment(new Date(r.StartTime)).format("h:mm a");
					if (r.StartTime == "" || String(this.StartTime).toLowerCase().indexOf("invalid") != -1) {
						this.StartTime = "N/A";
					}

					this.EndTime = moment(new Date(r.EndTime)).format("h:mm a");
					if (r.EndTime == "" || String(this.EndTime).toLowerCase().indexOf("invalid") != -1) {
						this.EndTime = "N/A";
					}

					this.ScheduleID = r.ScheduleID;
					this.RecurranceTypeID = r.RecurranceTypeID;
					this.RecurranceTypeDesc = r.RecurranceTypeDesc;

					this.RangeStartDate = moment(new Date(r.RangeStartDate)).format("MM/DD/YYYY");
					if (r.RangeStartDate == "" || String(this.RangeStartDate).toLowerCase().indexOf("invalid") != -1) {
						this.RangeStartDate = "N/A";
					}

					this.RangeEndDate = moment(new Date(r.RangeEndDate)).format("MM/DD/YYYY");
					if (r.RangeEndDate == "" || String(this.RangeEndDate).toLowerCase().indexOf("invalid") != -1) {
						this.RangeEndDate = "N/A";
					}
				} else {
					this.EventScanID = "N/A";
					this.EventID = "N/A";
					this.EventDescriptionID = "N/A";
					this.EventDescShort = "N/A";
					this.EventDescLong = "N/A";
					this.EventLocation = "N/A";
					this.EventDT = "N/A";
					this.DoorsOpenTime = "N/A";
					this.StartTime = "N/A";
					this.EndTime = "N/A";
					this.ScheduleID = "N/A";
					this.RecurranceTypeID = "N/A";
					this.RecurranceTypeDesc = "N/A";
					this.RangeStartDate = "N/A";
					this.RangeEndDate = "N/A";
				}
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////////

	/////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////
	GetScanType() {
		if (this.SelectedEntry != undefined) {
			return this.SelectedEntry.StationModeID;
		}

		return 0;
	}

	/////////////////////////////////////////////
}
